import React from "react";
import AliceCarousel from "react-alice-carousel";
import GalleryItem from "./GalleryItem";
import "react-alice-carousel/lib/alice-carousel.css";
import wave from "../assets/images/wave.png";
import logo from "../assets/images/logo.png";
import earth from "../assets/images/earth.png";
import controller from "../assets/images/controller.png";
import earthcontroller from "../assets/images/earth_controller.png";
import { data } from "../constants/data";

const handleDragStart = (e) => e.preventDefault();

const items = []

data.forEach((item) => {
  items.push(<GalleryItem key={item.name} item={item} />)
})

export default function Gallery() {
    return <div className="gallery">
        {items}
    </div>
}
